import { Component, Input, OnInit } from '@angular/core';

import * as _ from 'lodash-es';
import { StateService } from '@uirouter/angular';
import { FilterService } from '../../../../services/core.filter.service';
import { UiService } from '../../../../services/core.ui.service';
import { CronReportHelper } from './reports.cron.service.component';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { HttpClient } from '@angular/common/http';
import { buildQueryString, doGetPromise } from '../../../../config/core.httpclient-utils';

@Component({
    selector: 'siteCronHistoryView',
    template: require('./reports.cron.component.html')
})
export class SiteCronHistoryComponent implements OnInit {
    protected active = '';

    protected data: any = [];
    protected filters: any = false;

    private url: string = '/api/admin/0/cron';

    protected sortFields: any = {};
    private sort: any = {};
    private paging: any = {};
    private baseFilters: any = {};

    constructor(
        private stateService: StateService, 
        
        private filterService:  FilterService,
        private uiService:  UiService,
        private cronReportHelper:  CronReportHelper,
        private httpClient: HttpClient,
        private gfTranslateService:  GfTranslateService,
    ) { }
    
    ngOnInit() {
        this.sortFields = this.cronReportHelper.getSortFields();
        this.sort = this.filterService.getSortValues();
        this.paging = this.filterService.getPagingValues(1, 50);
        this.baseFilters = this.cronReportHelper.getBaseFilters();
        this.filters = this.initFilters();
        this.refreshData();
    };

    onApplyFilters = () => {
        this.paging.page_num = 1;
        this.applyFilters();
    };

    onResetFilters = () => {
        this.paging.page_num = 1;
        this.filters = {
            main_fields: _.cloneDeep(this.baseFilters)
        };
        this.applyFilters();
    };

    onSort = (params) => {
        this.sort = {
            sort_field: _.get(params, 'key', 'id'),
            sort_dir: _.get(params, 'sortDir', 'desc')
        };
        this.applyFilters();
    };

    getDownloadUrl = (format) => {
        var fetchArgs = this.filterService.getFetchArgs({});
        fetchArgs.download = true;
        fetchArgs.format = format;
        delete fetchArgs.$inherit;  // Why is this in here?

        return this.url + '?' + buildQueryString(fetchArgs);
    };

    onPaging (params) {
        _.assignIn(this.paging, params);
        this.applyFilters();
    };

    refreshData = () => {
        this.data = null;

        var fetchArgs = this.filterService.getFetchArgs({});

        doGetPromise(this.httpClient, this.url, fetchArgs)
        .then(
            (response) => {
                this.data = _.get(response, 'items', []);
            },
            (response) => {
                console.log(response);
                this.data = [];
                var msg = this.gfTranslateService.translate('There was a problem loading cron data');
                this.uiService.message.showWarning(msg, 'Data Error');
            }
        );
    };

    getDetails (row) {
        if (row.output.length < 100) return false;

        if (!row.fullOutput) {
            var url = '/api/admin/0/cron/' + row.id;
            doGetPromise(this.httpClient, url)
            .then(
                (response) => {
                    row.fullOutput = _.get(response, 'output', row.output);
                    row.showFull = true;
                },
                (response) => {
                    console.log(response);
                    var msg = this.gfTranslateService.translate('Sorry, could not fetch details for ID ' + row.id);
                    this.uiService.message.showWarning(msg, 'Fetch Details');
                }
            );
        } else {
            row.showFull = !row.showFull;
        }
    }

    initFilters() {
        return {
            main_fields: this.cronReportHelper.setFiltersFromStateParams(
                _.cloneDeep(this.baseFilters)
            )
        };
    }

    applyFilters(overrides = {}) {
        var newParams = _.pickBy(Object.assign(
            {},
            this.sort,
            this.paging,
            this.filterService.getFilterValues(
                _.get(this.filters, 'main_fields', [])
            ),
            overrides
        ), (value) => {
            return (undefined != value && null != value && value != '');
        });

        // This call needs inherit: false to allow
        // empty params to replace non-empty values in route/URL
        // (e.g., s=maillog => s='')
        this.stateService.go('.', newParams, { location: 'replace', inherit: false })
            .then(this.refreshData);
    }
}
